import useIsDesktop from "@hooks/useIsDesktop"

import { BottomBar } from "@organisms"
import MainSideBar from "@organisms/SideBar/MainSideBar/MainSideBar"

import { AppFrame } from "@templates"

import styles from "./Menu.module.scss"

export default function Menu() {
    const isDesktop = useIsDesktop()

    return (
        <AppFrame.Root>
            {!isDesktop && (
                <>
                    <div className={styles.sidebar}>
                        <MainSideBar hideCreateButton={true} />
                    </div>
                    <BottomBar />
                </>
            )}
        </AppFrame.Root>
    )
}
